import AllPublished from './components/AllPublished.vue'
import EngagementFinder from './components/EngagementFinder.vue'
import Published from './components/Published.vue'
import RejectedByCom from './components/RejectedByCom.vue'
import RejectedByManager from './components/RejectedByManager.vue'
import validatedByCom from './components/validatedByCom.vue'
import RangeConfiguration from './components/RangeConfiguration.vue'

export default {
    AllPublished,
    EngagementFinder,
    Published,
    RejectedByCom,
    RejectedByManager,
    validatedByCom,
    RangeConfiguration


}
window.version = window.version || []
window.version['EngagementFinder'] = "0.0.6"